module.exports = __webpack_public_path__ + "img/ic-open-link.80ce461d.svg";